import { ChangeDetectionStrategy, Component, Input, OnInit, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Question } from 'src/app/models/question.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { map } from 'rxjs';
import { ImageComponent } from "../../../question-form/components/image/image.component";
import { QuestionnaireApiService } from 'src/app/services/questionnaire-api.service';
import { EImageStatus } from 'src/app/models/EnumImageStatus';

@Component({
    selector: 'que-image-display',
    templateUrl: './image-display.component.html',
    styleUrls: ['./image-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, ImageComponent]
})
export class ImageDisplayComponent{
  @Input()
  question?: Question;
  @Input() viewAnswer = false;
  #questionnaireStore = inject(QuestionnaireStore);

  enumImageStatus=EImageStatus;
  image$ = signal<string | undefined>(undefined);
  isUser$ = toSignal(this.#questionnaireStore.isUser$);
  questionId$ = signal<number | null>(null);
  constructor() {
  }
}
